import react from  'react'
import LogoReport from './logo report/logo-report'
const ReportFormList = (props) => {
    
    const downlaodReport = async ()=>{
        let response = await LogoReport('download');
        console.log(response, 'response')
    }

    return(
        <div className='content-wrapper'>
        <button onClick={downlaodReport}>
        Download Logo Report
        </button>
        </div>
    )
}
export  default ReportFormList